import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingInformationFormComponent } from './billing-information-form.component';
import { MaterialModule } from '../../../modules/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { I18NextModule } from 'angular-i18next';



@NgModule({
  declarations: [
    BillingInformationFormComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    I18NextModule.forRoot(),
  ],
  exports: [
    BillingInformationFormComponent
  ]
})
export class BillingInformationFormModule { }
